import { createContext } from 'react';

const NotificationContext = createContext(void 0);

NotificationContext.displayName = 'context(Notification)';

export default NotificationContext;